define('view/controller/booking/service/ServiceItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var ThemeSettings = require('lib/theme/ThemeSettings');
	
	/**
	 * Service info view (service item)
	 * 
	 * @class ServiceItemView
	 */
	return LayoutView.extend({
	
	    getTemplate: function () {
	    	if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
				return '#service_item_list';
			}
	    	return '#service_item';
		},

		onRender: function () {
            Backbone.Wreqr.radio.vent.trigger('step:item', 'render', {
                'stepItem': 'service',
                'model': this.model,
				'view': this
            });
		},

		onDomRefresh: function () {
			Backbone.Wreqr.radio.vent.trigger('items', 'shown', {
				'page': 'booking_service_item'
			});
		}

	});
	
});
